import React, { useState } from "react";
import CustomLink from "../../../components/shared/custom-link";
import AskEmail from "./ask-email";
import OtpVerify from "./otp-verify";
import loginImage from '../../../assets/images/loginImgnew.png';
import logo from '../../../assets/images/logo-trans.png';

const ForgotPassword = () => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        email: "",
        otp: "",
        password: "",
        confirmPassword: "",
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };

    return (
        <div className="grid bg-bg  md:grid-cols-2 grid-cols-1 !px-0 gap-6 min-h-screen">

            <div className='p-8 md:flex hidden'>
                <img src={loginImage} className='w-full h-full object-contain' alt="Login illustration" />
            </div>
            <div className='flex bg-white justify-start py-6 sm:px-8 px-4'>
                <div className='flex flex-col items-center justify-center xl:w-[75%] lg:w-[85%] w-full'>

                    <img
                        src={logo}
                        className="h-9 object-contain"
                        alt="Logo"
                    />


                    <div className="mb-6 mt-3 w-full">
                        <h2 className="text-2xl text-center font-bold text-gray-800 mb-2">Forgot Password</h2>
                        <p className="text-gray-600 text-center">
                            {step === 1
                                ? "Enter your email to receive a verification code"
                                : step === 2
                                    ? "Enter the verification code sent to your email"
                                    : "Set your new password"}
                        </p>
                    </div>

                    {step === 1 && (
                        <AskEmail
                            formData={formData}
                            handleChange={handleChange}
                            setFormData={setFormData}
                            setStep={setStep}
                            setErrors={setErrors}
                            errors={errors}
                        />
                    )}

                    {step === 2 && (
                        <OtpVerify
                            formData={formData}
                            setFormData={setFormData}
                            errors={errors}
                            setErrors={setErrors}
                            setStep={setStep}
                            handleChange={handleChange}
                        />
                    )}

                    <p className="text-center text-gray-600 mt-3">
                        Remember your password?{' '}
                        <CustomLink to="/" className="text-blue-600 hover:underline">
                            Login
                        </CustomLink>
                    </p>

                    <p className='text-gray-400 text-center mt-3 text-sm'>© 2025 YoGPS™. All rights reserved.</p>
                </div>

            </div>
        </div>
    );
};

export default ForgotPassword;